import { Patient, PatientActionHistoryItem, PatientActionHistoryItemEnum } from 'generated/graphql'

export default function getActionItemHistoryItem(
  patient: Patient,
  action: PatientActionHistoryItemEnum
): PatientActionHistoryItem | undefined | null {
  return patient?.actionHistory?.find((item) => item?.name === action)
}
